import React, { useEffect, useState } from "react";
import API from "api";
import "./cms-block.css";
import { getTemplate } from "./templates";

export default function CMSBlock({
  blockId = null,
  template: templateProp = null,
  className = "",
  ...restProps
}) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (blockId) {
      loadBlock();
    } else {
      setData(restProps);
    }
  }, [blockId]);

  const loadBlock = async () => {
    try {
      setLoading(true);
      API.handleError = false;
      const res = await API.get(`/cms/${blockId}/contents`);
      setData(res.data || {});
    } catch (e) {
      console.error("CMSBlock error:", e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={`cms-block ${className} text-muted`}>
      </div>
    );
  }

  const block = {
    ...restProps, // props explicites
    ...data,      // surcharge API
  };

  if (!block.title && !block.text) {
    return null;
  }

  const templateName = templateProp || block.template || "default";
  const TemplateComponent = getTemplate(templateName);

  const rootClassName = [
    "cms-block",
    className,
    block.className,
  ].filter(Boolean).join(" ");

  return (
    <div className={rootClassName}>
      <TemplateComponent block={block} />
    </div>
  );
}
